import Storage from 'services/storage'
import {
  isLocalStorageAllowedSelector
} from 'selectors/gdpr'
import { isEventOwnerSelector } from 'selectors/event_type'
import { isPublisherSelector } from 'selectors'


const storage = new Storage('invitees')

const isLocalStorageAllowed = (state) => (
  isLocalStorageAllowedSelector('functional')(state)
    && !isEventOwnerSelector(state)
    && !isPublisherSelector(state)
)

const isAutofillAvailable = (eventType) => eventType.booking_autofill

const getName = (eventType, data) => {
  switch (eventType.invitee_name_format) {
    case 'combined':
      return {
        full_name: data.full_name.value
      }
    case 'separated':
      return {
        first_name: data.first_name.value,
        last_name: data.last_name.value
      }
    default:
      return undefined
  }
}

const getEmail = (eventType, data) => ({
  email: data.email.value
})

const getPhone = (eventType, data) => {
  if (eventType.sms_reminder_enabled) {
    return {
      phone_number: data.phone_number.value
    }
  }

  return undefined
}

const writeToLocalStorage = (data) => storage.set('invitee', JSON.stringify(data))

export const maybeRetrieveData = (state, eventType) => {
  if (isAutofillAvailable(eventType) && isLocalStorageAllowed(state)) {
    const storedInvitee = storage.get('invitee')
    if (!storedInvitee) {
      return {}
    }
    return JSON.parse(storedInvitee) || {}
  }
  return {}
}

export const maybeStoreData = (state, eventType, data) => {
  if (!isLocalStorageAllowed(state)) {
    return undefined
  }

  if (!isAutofillAvailable(eventType)) {
    return writeToLocalStorage({})
  }

  if (!data) {
    return undefined
  }

  const updateData = Object.assign({},
    maybeRetrieveData(state, eventType),
    getName(eventType, data),
    getEmail(eventType, data),
    getPhone(eventType, data)
  )

  return writeToLocalStorage(updateData)
}
